// src/pages/docs/overwatch/info.jsx
import { Typography, Box, Link, Button } from '@mui/material';
import DocsLayout from 'layout/DocsLayout';
import commandList from 'data/commands';
import { useLocation } from 'react-router-dom';
import { getAdjacentCommands } from 'components/getAdjacentCommands';

const OwtierCommand = () => {
  const location = useLocation();
  const command = commandList.find((cmd) => cmd.path === location.pathname);
  const { prev, next } = getAdjacentCommands(location.pathname);

  return (
    <DocsLayout>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 4, flexWrap: 'wrap', maxWidth: 900 }}>
        {/* 왼쪽 텍스트 영역 */}
        <Box sx={{ flex: 1, minWidth: 260 }}>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            {"/옵치 정보"}
          </Typography>
          <Typography variant="body1" sx={{ mt: -2, mb: 3 }}>
          {command?.description ?? '설명이 없습니다.'}<br />/옵치 등록 명령어 사용 시 배틀태그 입력이 불필요합니다.
          </Typography>
          <Typography variant="h6">
            {"사용법: /옵치 정보 <종류> [배틀태그] [플랫폼] [게임모드] [영웅]"}<br />{"<>는 필수, []는 선택 사항입니다."}
          </Typography>
          <Typography variant="body1" sx={{ mt: 3}}>
          {"예시: /옵치 정보 평균기록 티칩#3577 경쟁전 아나"}<br /><br />
          {"<종류>: 최고기록, 평균기록, 전투기록, 승리 패배중 한 가지를 선택합니다."}<br />
          {"[배틀태그]: 전적을 확인할 배틀태그를 입력합니다."}<br />
          {"[플랫폼]: 컴퓨터, 콘솔 중 한 가지를 선택합니다. 기본값: 컴퓨터"}<br />
          {"[게임모드]: 경쟁전, 빠른대전 중 한 가지를 선택합니다. 기본값: 빠른대전"}<br />
          {"[영웅]: 영웅별 정보를 확인할 수 있습니다.(한글 입력)"}<br />
          </Typography>          
        </Box>

        {/* 오른쪽 이미지 영역 */}
        <Box
          component="img"
          src="/commands/owinfo.png"
          alt="설명 이미지"
          sx={{
            width: '100%',
            maxWidth: 400,
            borderRadius: 2,
            flexShrink: 0,
            mx: 'auto',
          }}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: { xs: 'center', md: 'space-between' },
            gap: 4,
            width: { xs: '100%',md: 'auto' },
          }}
        >
        {prev && (
          <Button href={prev.path} variant="outlined"sx={{height: 36, width:118 }}>
            ← {prev.name}
          </Button>
        )}
        {next && (
          <Button href={next.path} variant="outlined"sx={{height: 36, width:118 }}>
            {next.name} →
          </Button>
        )}
        </Box>
      </Box>
    </DocsLayout>
  );
};

export default OwtierCommand;
